import { render, staticRenderFns } from "./FiltroProposta.vue?vue&type=template&id=791a7b3b&scoped=true&"
import script from "./FiltroProposta.vue?vue&type=script&lang=js&"
export * from "./FiltroProposta.vue?vue&type=script&lang=js&"
import style0 from "./FiltroProposta.vue?vue&type=style&index=0&id=791a7b3b&scoped=true&lang=css&"
import style1 from "./FiltroProposta.vue?vue&type=style&index=1&id=791a7b3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791a7b3b",
  null
  
)

export default component.exports